import React from 'react'

function SubHead(props) {
  return (
    <p className=' font-medium text-lg text-subhead'>{props.subhead}</p>
  )
}

export default SubHead